import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import { IDate, IPayrollPayCalendar, EExceptionType, IUserFilter } from "../../../models"
import * as reportAction from "../../../actions/ReportAction"
import AccountStore from "../../../stores/AccountStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import moment from "moment"
import * as timecardHelper from "../../../helpers/timecardHelper"
import * as payrollHelper from "../../../helpers/payrollHelper"
import { AdhocReportDateRange } from "./AdhocReportDialog"

interface IProps {
    referenceDate: IDate
    selectedPayrollPayCalendar: IPayrollPayCalendar
    userFilter: IUserFilter
    handleClose(): void

    // job->Timecard report
    jobId: string

    // Timecard page report
    filterByDefaultHierarchy: boolean
    filterDirectReportsOnly: boolean
    filterByPunchHierarchy: boolean
    filterByException: boolean
    filterExceptions: EExceptionType[]
}
interface IState {
    startDate: IDate
    endDate: IDate
    isValid: boolean
}

export default class ManualEntriesReportDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const timecardDates = timecardHelper.getTimecardDateByPayrollPayCalendar(props.referenceDate, props.selectedPayrollPayCalendar)
        this.state = {
            startDate: moment(timecardDates.StartDate).utc(true).format(),
            endDate: moment(timecardDates.EndDate).utc(true).format(),
            isValid: true
        }
        autobind(this)
    }

    handleExport() {
        if (!this.state.isValid) return
        this.props.handleClose()
        const payGroupIds = payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar)
        this.props.jobId ?
            reportAction.downloadJobTimecardManualEntriesReport(
                AccountStore.getCurrentAccount().Id,
                this.props.jobId,
                this.state.startDate as string,
                this.state.endDate as string,
                payGroupIds,
                this.props.userFilter
            ) :
            reportAction.downloadManualEntriesReport(
                AccountStore.getCurrentAccount().Id,
                this.state.startDate as string,
                this.state.endDate as string,
                HierarchySettingsStore.getGlobalLevelItemFilterId(),
                payGroupIds,
                this.props.userFilter,
                this.props.filterByDefaultHierarchy,
                this.props.filterDirectReportsOnly,
                this.props.filterByPunchHierarchy,
                this.props.filterByException,
                this.props.filterExceptions
            )
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Manual_Entries_Report}
                actions={[
                    <FlatButton data-intercom-target={"Timecards-Reports-Btn-CloseManualEntriesReportDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
                    <FlatButton data-intercom-target={"Timecards-Reports-Btn-ExportManualEntriesReport"} key="export" label={strings.Export} primary onTouchTap={this.handleExport} />
                ]}
            >
                <AdhocReportDateRange
                    dateRange={{ StartDate: this.state.startDate as string, EndDate: this.state.endDate as string }}
                    selectedPayrollPayCalendar={this.props.selectedPayrollPayCalendar}
                    handleChange={(dateRange, isValid) => this.setState({ startDate: dateRange.StartDate, endDate: dateRange.EndDate, isValid })}
                />
            </Dialog>
        )
    }
}